import { Col, Row } from "reactstrap";
import BlogCard from "./BlogCard";
import LatestNewsAndTrends from "./LatestNewsAndTrends";

const BlogBody = () => {
  return (
    <Col xxl="9" xl="8" className="box-col-12">
      <Row>
        <BlogCard />
        <LatestNewsAndTrends/>
      </Row>
    </Col>
  );
};
export default BlogBody